import type { TaskDto } from './task-api'
import type { TaskPriority, TaskRecord, TaskStatus } from '../types'

const STATUS_SET = new Set<TaskStatus>([
  'pending',
  'processing',
  'done',
  'cancelled',
  'overdue',
])
const PRIORITY_SET = new Set<TaskPriority>(['low', 'normal', 'high', 'urgent'])

function normalizeStatus(value: string): TaskStatus {
  if (STATUS_SET.has(value as TaskStatus)) {
    return value as TaskStatus
  }
  return 'pending'
}

function normalizePriority(value: string): TaskPriority {
  if (PRIORITY_SET.has(value as TaskPriority)) {
    return value as TaskPriority
  }
  return 'normal'
}

function formatDateTime(value?: string) {
  if (!value) return new Date().toISOString()
  return value
}

export function mapTaskDto(dto: TaskDto): TaskRecord {
  return {
    id: String(dto.id),
    title: dto.title,
    description: dto.description,
    status: normalizeStatus(dto.status),
    priority: normalizePriority(dto.priority),
    module: dto.module,
    bizType: dto.bizType,
    assignee: dto.assigneeName ?? String(dto.assigneeId ?? ''),
    creator: dto.creatorName ?? String(dto.creatorId ?? ''),
    dueTime: dto.dueTime,
    createTime: formatDateTime(dto.createTime),
    bizTab: dto.bizRoute,
    payload: dto.bizPayload,
  }
}

export function mapTaskList(dtos: TaskDto[]): TaskRecord[] {
  return dtos.map(mapTaskDto)
}
